<template>
  <section class="custom-progress" :style="{ width: width + 'px' }">
    <vue-highcharts
      type="chart"
      ref="vchart"
      :options="options"
      :redrawOnUpdate="true"
      :oneToOneUpdate="false"
      :animateOnUpdate="true"
    />
  </section>
</template>
<script>
import VueHighcharts from 'vue3-highcharts'
import globals from '@/Plugins/globals'
export default {
  name: 'progress-sparkline',
  components: {
    VueHighcharts,
  },
  props: {
    progress: {
      type: [Array, Number, String],
      default: 0,
    },
    width: {
      type: Number,
      default: 120,
    },
  },
  computed: {
    options() {
      let _data = []
      if (this.progress) {
        let temp = JSON.parse(JSON.stringify(this.progress))
        temp.reverse()
        temp.forEach((element) => {
          _data.push(element.progress)
        })
      }
      console.log('Daily Progress Sparkline Data', this.progress)
      let _options = {
        chart: {
          backgroundColor: null,
          borderWidth: 0,
          type: 'area',
          margin: [2, 0, 2, 0],
          width: 120,
          height: 30,
          style: {
            overflow: 'visible',
          },
          // small optimalization, saves 1-2 ms each sparkline
          skipClone: true,
        },
        title: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          labels: {
            enabled: false,
          },
          title: {
            text: null,
          },
          startOnTick: false,
          endOnTick: false,
          tickPositions: [],
        },
        yAxis: {
          endOnTick: false,
          startOnTick: false,
          labels: {
            enabled: false,
          },
          title: {
            text: null,
          },
          tickPositions: [0],
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          hideDelay: 0,
          outside: true,
          formatter: function () {
            return '<b>' + this.x + ': ' + this.y + '</b>'
          },
        },
        plotOptions: {
          series: {
            animation: false,
            lineWidth: 1,
            shadow: false,
            states: {
              hover: {
                lineWidth: 1,
              },
            },
            marker: {
              radius: 2,
              states: {
                hover: {
                  radius: 2,
                },
              },
            },
            fillOpacity: 0.25,
          },
          column: {
            negativeColor: '#910000',
            borderColor: 'silver',
          },
        },
        series: [
          {
            data: _data,
            pointStart: 1,
          },
        ],
      }
      return _options
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-progress {
  width: 120px;
  height: auto;
  text-align: center;
  margin: 0 auto;
}
</style>
